import { render } from "./ProjectDetails.vue?vue&type=template&id=373922f5&scoped=true"
import script from "./ProjectDetails.vue?vue&type=script&lang=js"
export * from "./ProjectDetails.vue?vue&type=script&lang=js"

import "./ProjectDetails.vue?vue&type=style&index=0&id=373922f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373922f5"]])

export default __exports__